<template>
  <section class="leading-7 pt-8 pb-6">
    <PageTitle
      :content="t('SpO₂ to PaO₂')"
      :subcontent="t('Calculator')"
      class="text-xl font-bold md:text-2xl pb-4 px-0 md:pt-2"
    />
  </section>
</template>

<script setup>
import PageTitle from '@/common/components/PageTitle.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
